import { useNavigate } from 'react-router-dom';
import { MenuItem } from '@mui/material';
import Iconify from '@/components/iconify/index.tsx';

export const UserSelectionButton = ({
  pickemId,
  userId,
}: {
  pickemId: number;
  userId: number | null;
}) => {
  const navigate = useNavigate();

  if (!pickemId) return null;

  return (
    <>
      <MenuItem
        onClick={() =>
          navigate(
            `/dashboard/user-selections?pickem_id=${pickemId}&user_id=${userId}`
          )
        }
      >
        <Iconify icon={'eva:eye-outline'} sx={{ mr: 1 }} />
        User Selections
      </MenuItem>
    </>
  );
};